import React, { useState } from "react";
import { MDBCardImage, MDBFile } from "mdb-react-ui-kit";

export default function MultipleImageUploadComponent({ onFileSelect }) {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [imageSrcs, setImageSrcs] = useState([]);

  const handleChange = (event) => {
    const files = Array.from(event.target.files);
    
    // Handle each file
    files.forEach(file => {
      // Check file size (50MB limit)
      if (file.size > 50 * 1024 * 1024) {
        alert(`File ${file.name} is too large. Maximum file size is 50MB.`);
        return;
      }
      
      // Check file type
      if (!file.type.startsWith('image/')) {
        alert(`File ${file.name} is not an image. Please select image files only.`);
        return;
      }
      
      // Add file to selected files
      setSelectedFiles(prev => [...prev, file]);
      onFileSelect(file);
      
      // Create preview
      const reader = new FileReader();
      reader.onload = (e) => {
        setImageSrcs(prev => [...prev, e.target.result]);
      };
      reader.readAsDataURL(file);
    });
  };

  return (
    <div className="custom-file-input mt-3 mb-3">
      <MDBFile 
        onChange={handleChange} 
        multiple 
        accept="image/*"
      />
      <div className="container mt-2 mx-4">
        {imageSrcs.map((src, index) => (
          <MDBCardImage
            key={index}
            className="img-fluid border border-info border-3 m-1"
            style={{ width: "120px", height: "120px", borderRadius: "5px" }}
            src={src}
            fluid
          />
        ))}
      </div>
    </div>
  );
}